export default __webpack_public_path__ + "static/media/one.b66980a2.jpeg";